<template>
  <div class="b-seats">
    <div class="b-seats__wrapper">
      <div
        v-if="!desktop"
        class="b-seats__mobile-actions__wrapper b-seats__mobile-actions__wrapper--to-right">
        <div class="b-seats__mobile-actions__right-actions">
          <button
            type="button"
            class="btn--minus-icon"
            @click="zoomOutSeats"></button>
          <button
            type="button"
            class="btn-plus-icon"
            @click="zoomIntoSeats"></button>
        </div>
      </div>
      <div class="b-seats__matrix-wrapper">
        <div id="seatsContainer" class="b-seats__matrix">
          <div class="b-seats__screen">
            <div class="b-seats__screen-title">{{ dictionary.screen }}</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1003 52"
              fill="none">
              <path
                d="M0 13.6991C0 11.611 1.57574 9.88076 3.65901 9.73966C26.8813 8.16677 163.72 0 501.5 0C839.28 0 976.119 8.16677 999.341 9.73966C1001.42 9.88076 1003 11.611 1003 13.6991V47.6746C1003 50.0068 1001.1 51.8573 998.773 51.7014C973.958 50.0391 836.628 42 501.5 42C166.372 42 29.0422 50.0391 4.22696 51.7014C1.89998 51.8573 0 50.0068 0 47.6746V13.6991Z"
                fill="#202828" />
            </svg>
          </div>
          <div class="b-seats__matrix-holder">
            <div
              v-for="(row, index) in rows"
              :key="index"
              class="b-seats__row"
              :style="columnCount(totalColumns)">
              <Seat
                v-for="seat in row.seats"
                :key="seat.physicalName + seat.id"
                :seat="seat"
                @choose-seat="chooseSeat"></Seat>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch } from 'vue'
import Panzoom from '@panzoom/panzoom'
import useViewport from '../../../../features/viewport'
import Seat from './Seat.vue'

const { desktop } = useViewport()

defineProps({
  totalRows: { default: 0, type: Number },
  totalColumns: { default: 0, type: Number },
  rows: {
    default() {
      return []
    },
    type: Array,
  },
})

const emit = defineEmits(['recall-seats', 'choose-seat'])

const zoomScale = ref(1)
const maxScale = 5
const panzoom = ref(null)

const columnCount = (count) => {
  return {
    '--width': `${count}`,
  }
}

watch(
  () => desktop.value,
  (newVal) => {
    if (newVal) {
      resetZoomPan()
    }
  }
)

const chooseSeat = (seat) => {
  emit('choose-seat', seat)
}

const zoomIntoSeats = () => {
  if (zoomScale.value < maxScale) {
    zoomScale.value += 1
    panzoom.value.zoom(zoomScale.value, { animate: true, contain: 'outside' })
  }
}

const zoomOutSeats = () => {
  if (zoomScale.value !== 1) {
    zoomScale.value -= 1
    panzoom.value.pan(0, 0, { animate: true })
    panzoom.value.zoom(zoomScale.value, { animate: true, contain: 'outside' })
  }
}

const applyZoomBehavior = () => {
  const elem = document.getElementById('seatsContainer')
  if (elem) {
    panzoom.value = Panzoom(elem, {
      maxScale: maxScale,
      panOnlyWhenZoomed: true,
      cursor: '',
    })
  }
}

const resetZoomPan = () => {
  if (panzoom.value) {
    nextTick(() => {
      panzoom.value.reset({ animate: true })
      panzoom.value.destroy()
    })
  }
}

onMounted(() => {
  nextTick(() => {
    applyZoomBehavior()
  })
})
</script>
